import React, { useState ,useEffect} from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import Dialog from '@material-ui/core/Dialog';
import fire from "./config/fire";
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import axios from "axios";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Detail from "./Detail";
import Servers from "./Servers";
import Howitworks from "./Howitworks";
import Howtodownload from "./Howtodownload";
import SearchIcon from "@material-ui/icons/Search";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DnsIcon from '@material-ui/icons/Dns';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Fab from "@material-ui/core/Fab";
import Footer from "./Footer";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CardActionArea from "@material-ui/core/CardActionArea";
import Welcome from 'react-welcome-page'
import Snackbar from '@material-ui/core/Snackbar';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import InfoIcon from '@material-ui/icons/Info';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import SettingsIcon from '@material-ui/icons/Settings';


const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

 




const Home = () => {
  const theme = useTheme();
  const [stext, setstext] = useState("avengers");
  const [result, setresult] = useState([]);
  const [result2, setresult2] = useState([]);
  const [favList, setfavList] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openFav, setOpenFav] = React.useState(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down("xl"));
  const [openServer, setOpenServer] = React.useState(false);
  const [openDownload, setOpenDownload] = React.useState(false);
  const [openWorks, setOpenWorks] = React.useState(false);
  

  
  const [detailbool, setdetailbool] = useState(false);
  const [imval, setimval] = useState();
  
 
 

  const showChange = (event) => {
    setstext(event.target.value.toLowerCase());
  };
  const show = () => {
    axios
      .get(`https://www.omdbapi.com/?apikey=4eb65943&s=${stext}`)
      .then((res) => {
        setresult(res.data.Search.map((p) => p));
      })
      .catch((error) => {
        //alert("No search results found!! check for spelling ");
        setOpen(true);
      });
      show2();
     
  };

  const show2 = () => {
    axios
    .get(`https://www.omdbapi.com/?apikey=5fcb333a&s=${stext}&page=2`)
    .then((res) => {
      setresult2(res.data.Search.map((s) => s));
      
    })
    .catch((error) => {
     
    });
    
      

  };
  function showDetail(i) {
    setdetailbool(true);
    setimval(i);
  }
  //to toggle boolean
  function funsetdetailbool() {
    setdetailbool(false);
  }
  
  useEffect(() => {
    show();
  }, []);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const handleClickOpenServer = () => {
    setOpenServer(true);
    
   
  };
  
  const handleCloseServer = () => {
    setOpenServer(false);
    
  };
  const handleClickOpenDownload = () => {
    setOpenDownload(true);
    
   
  };
  
  const handleCloseDownload = () => {
    setOpenDownload(false);
   
  };
  const handleClickOpenWorks = () => {
    setOpenWorks(true);
    
   
  };
  
  const handleCloseWorks = () => {
    setOpenWorks(false);
   
  };

  // dashboard start
  const classes = useStyles();
  const [state, setState] = React.useState({
    
    left: false,
    
  });
  const logOut=()=>{
    fire.auth().signOut();
  }

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div 
    style={{backgroundColor:"#313131",color:"lightgray",height:"100%"}}
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List className="listItem">
        {<> <br/>
            
           <ListItem ><p >&nbsp;&nbsp;<b>Watch Any Movie</b></p></ListItem>
           
           <br/>
           <Divider style={{backgroundColor:"#525252"}}/>

           
           <ListItem ><AccountCircleIcon /> &nbsp;&nbsp;&nbsp;&nbsp;My Account</ListItem>
           
           <ListItem onClick={handleClickOpenFav}><FavoriteBorderIcon/> &nbsp;&nbsp;&nbsp;&nbsp;Favourites</ListItem>
           <ListItem onClick={handleClickOpenWorks}><SettingsIcon/> &nbsp;&nbsp;&nbsp;How it Works</ListItem>
           <ListItem onClick={handleClickOpenServer} ><DnsIcon/> &nbsp;&nbsp;&nbsp;How to choose servers</ListItem>
           <ListItem  onClick={handleClickOpenDownload} ><CloudDownloadIcon/> &nbsp;&nbsp;&nbsp;How to Download</ListItem>
           {/* <Servers/> */}
           
           <ListItem  ><a href="https://amoldalwai.github.io/" style={{color:"white",textDecoration:"none"}}><InfoIcon/> &nbsp;&nbsp;&nbsp;About Me</a></ListItem>
           <hr/>
           
           <ListItem  onClick={logOut}><ExitToAppIcon /> &nbsp;&nbsp;&nbsp;&nbsp;Logout</ListItem>
           
            
         </>
        }
      </List>
      
    </div>
  );

  // dashboard end

  //add fvourite dialog box controls
  const handleClickOpenFav = () => {
    setOpenFav(true);
    
    var userID=fire.auth().currentUser.uid
    fire
          .database()
          .ref(userID)

          .once("value", (snapshot) => {
            
            
              snapshot.forEach((moviesval) => {
                //console.log(moviesval.val().movies);
                //setposterval(moviesval.val().movies)
                //setfavList({ ...favList, x});
             // <span>{moviesval.val().movies}</span>
                setfavList(favList=>[...favList,moviesval.val().movies]);
              });
            
          });
          

  };
 
  // const favMovies=()=>(
    
  //   <div>
  //     {
  //           fire
  //           .database(fire.auth().currentUser.uid)
  //           .ref()
  
  //           .once("value", (snapshot) => {
              
              
  //               snapshot.forEach((moviesval) => {
                 
  //                <p> {moviesval.val().movies}</p>
  //               })
              
  //           })
  //     }
      
      

  //     </div>



  // );

  const deleteFav=()=>{
    var userID=fire.auth().currentUser.uid;
    try{fire.database().ref(userID).remove();handleCloseFav();}
    catch{
      console.log()
    }


  }




  const handleCloseFav= () => {
    setOpenFav(false);
    //console.log(favList)
    setfavList([]);
  };




  return (
    <>
     <Welcome
		loopDuration={2000}
		data={[
		{
		
    image: require('./WatchAnyMovieLogo.png') ,
    imageAnimation: 'flip',
    backgroundColor: '#212121',
    // textAnimation: "flip",
    // textColor: 'white',
    // text:'Watch Any Movie'
    }
   
		// },
		// {
    //   image: require('./watchanymovie-logo.PNG') ,
    // imageAnimation: 'rotateIn',
    // backgroundColor: '#212121',
    // textAnimation: "fadeInUp",
    // textColor: 'white',
    // text:'Watch Any Movie'
		// },
		// { 
    //   image: require('./watchanymovie-logo.PNG') ,
    // imageAnimation: 'rotateIn',
    // backgroundColor: '#212121',
    // textAnimation: "fadeInUp",
    // textColor: 'white',
    // text:'Watch Any Movie'
		// }
	]}

/>

      <center>
        <div className=" navbar-dark bg-dark">
          <br />
          <span>
        {['left'].map((anchor) => (
          <React.Fragment key={anchor}>
            <Button onClick={toggleDrawer(anchor, true)} style={{position:"absolute",top:"30px",left:"-5px"}} ><MenuIcon  style={{color:"white",fontSize:"35px"}}/></Button>
            <SwipeableDrawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
            >
              {list(anchor)}
            </SwipeableDrawer>
          </React.Fragment>
        ))}
      </span>
          <input
            type="text"
            value={stext}
            onChange={showChange}
            placeholder="Search movies/series"
            style={{
              height: "57px",
              width: "200px",
              borderRadius: "5px",
              paddingLeft: "30px",
              color: "white",
              background: "#212121",
              border: "2px",
            }}
          />
          <Fab
            color="primary"
            aria-label="add"
            style={{
              background: "#b71c1c",
              borderRadius: "7px",
            }}
            onClick={show}
          >
            <SearchIcon  />
          </Fab>
          <br />
          <br />
        </div>
        <br />
        {/* <Display result={result}/> */}
        <center>
          <div className="resultContainer">
            {result.map((p) => (
              <div key={p.imdbID} onClick={() => showDetail(p.imdbID)}>
                <Card className="movieCard">
                  <CardActionArea>
                    <img className="moviePoster" src={p.Poster} alt={p.Title} />

                    <span
                      variant="contained"
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        background: "rgba(0, 0, 0, 0.5)",
                        color: "white",
                        borderRadius: "4px",
                      }}
                    >
                       {p.Year}
                    </span>
                    <div className="middle">
                      <div className="text">
                        <PlayCircleFilledIcon
                          className="playHoverIcon"
                          fontSize="large"
                          style={{ color: "#aa2e25", fontSize: "60px" }}
                        />
                      </div>
                    </div>
                    <div className="overlay">{p.Title}</div>
                  </CardActionArea>
                </Card>
              </div>
            ))}

            {/* result2 */}
            {result2.map((s) => (
              <div key={s.imdbID} onClick={() => showDetail(s.imdbID)}>
                <Card className="movieCard">
                  <CardActionArea>
                    <img className="moviePoster" src={s.Poster} alt={s.Title} />

                    <span
                      variant="contained"
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        background: "rgba(0, 0, 0, 0.5)",
                        color: "white",
                        borderRadius: "4px",
                      }}
                    >
                      <b> {s.Year}</b>
                    </span>
                    <div className="middle">
                      <div className="text">
                        <PlayCircleFilledIcon
                          className="playHoverIcon"
                          fontSize="large"
                          style={{ color: "#aa2e25", fontSize: "60px" }}
                        />
                      </div>
                    </div>
                    <div className="overlay">{s.Title}</div>
                  </CardActionArea>
                </Card>
              </div>
            ))}
          </div>
        </center>
        <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        style={{marginTop:"20vh"}}
        
        message="No search results found !!"/>

       

        {detailbool ? (
          <Detail imval={imval} funsetdetailbool={funsetdetailbool} />
        ) : null}
      </center>
           
           {/* Add to faourites Dialog */}
           <Dialog
           
        open={openFav}
        style={{marginLeft:"10px",marginRight:"10px",marginTop:"20px"}}
        fullScreen={fullScreen}

        onClose={handleCloseFav}
       
        

      >
        

         <div className="navbar-dark" style={{color:"white",backgroundColor:"#343A40"}}>
           <br/>
        <h3 align="center">Favourites</h3>
        <br/>
        </div>
        
      
        <div  className="resultContainer" style={{paddingTop:"20px",backgroundColor:"#212121",height:"auto"}}>
        
        {
        favList.map((s) =>(
          <Card className="movieCard">
         <img src={s} className="moviePoster" alt=""/>
         </Card>
        ))
        
        }
        
        </div>
        <div  style={{backgroundColor:"#212121",height:"100%"}}>
        </div>
        
        <IconButton
          onClick={handleCloseFav}
          style={{
            position: "absolute",
            top: "15px",
            left: "10px",
            color: "white",
            width: "60px",
            height: "60px",
            
            
          }}
        >
          <ArrowBackIcon fontSize="large" />
        </IconButton>
        <IconButton
          onClick={deleteFav}
          style={{
            position: "absolute",
            top: "15px",
            right: "10px",
            color: "white",
            width: "60px",
            height: "60px",
            
            
          }}
        >
          <DeleteForeverIcon fontSize="large" />
        </IconButton>
       


        </Dialog>

        {/* for best server info */}
        <Dialog
        fullScreen={fullScreen}
        open={openServer}
        // onClose={handleCloseServer}
        
        > 
                <IconButton
          onClick={handleCloseServer}
          style={{
            position: "absolute",
            top: "20px",
            left: "0px",
            color: "white",
            width: "60px",
            height: "60px",
          }}
        >
          <ArrowBackIcon fontSize="large" />
        </IconButton>
          <Servers/>
         </Dialog>

         {/* how to download */}
         <Dialog
        fullScreen={fullScreen}
        open={openDownload}
        // onClose={handleCloseDownload}
        
        > 
                <IconButton
          onClick={handleCloseDownload}
          style={{
            position: "absolute",
            top: "20px",
            left: "0px",
            color: "white",
            width: "60px",
            height: "60px",
          }}
        >
          <ArrowBackIcon fontSize="large" />
        </IconButton>
          <Howtodownload/>
         </Dialog>

         {/* how it works */}
         <Dialog
        fullScreen={fullScreen}
        open={openWorks}
        // onClose={handleCloseWorks}
        
        > 
                <IconButton
          onClick={handleCloseWorks}
          style={{
            position: "absolute",
            top: "20px",
            left: "0px",
            color: "white",
            width: "60px",
            height: "60px",
          }}
        >
          <ArrowBackIcon fontSize="large" />
        </IconButton>
          <Howitworks/>
         </Dialog>



      <Footer />
    </>
  );
};
export default Home;
